import { useContext } from 'react';
import { Typography, Box } from '@mui/material';
import LoggedInPage from 'src/components/page/LoggedInPage';
import WebStepper from 'src/components/WebStepper';
import AuthContext from 'src/store/auth-context';
import { colors } from 'src/styles/theme';

/**
 * PersonalPropertyForm is a form for gathering information about a personal property.
 * It consists of a stepper UI that displays multiple steps, each represented by a separate component.
 * The form steps and their corresponding components are defined in an array of objects, each with a `Component`, `label`, and `paths` prop.
 * The `WebStepper` component is used to render the stepper UI and the current step component.
 *
 * @returns {ReactElement} - A React element that renders the `WebStepper` component with the form steps as its children.
 */
export default function PersonalPropertyForm({ children }) {
  const { account } = useContext(AuthContext);

  return (
    <LoggedInPage>
      <Box
        sx={{
          bgcolor: colors.grey.formBg,
          borderRadius: 2,

          mt: 4,
          border: `1px solid ${colors.grey.formBorder}`,
        }}
      >
        <Box
          sx={{
            borderBottom: `1px solid ${colors.grey.formBorder}`,
            bgcolor: colors.white,
            py: 2,
            px: 3,
            borderRadius: '8px 8px 0px 0px',
            borderTop: '0px',
          }}
        >
          {account?.accountNo && (
            <Typography
              variant="h5"
              component="h1"
              sx={{
                fontSize: '20px',
                fontWeight: 600,
                color: 'text.primary',
              }}
            >
              Account #{account.accountNo}
            </Typography>
          )}
        </Box>
        <WebStepper />
        <Box sx={{ p: { xs: 2, md: 3 } }}> {children}</Box>
      </Box>
    </LoggedInPage>
  );
}
